export default function FeaturesSection() {
  const services = [
    {
      icon: 'ri-graduation-cap-line',
      title: '大学進学支援',
      description: '志望校選定から出願書類の作成、面接対策まで、一貫した総合的なサポートを提供。学生が目指す大学への入学を実現します。',
      image: 'https://public.readdy.ai/ai/img_res/6aa816d164060ede87aed44c19061561.jpg'
    },
    {
      icon: 'ri-user-heart-line',
      title: '学生後期サービス',
      description: '学業相談、キャリアカウンセリング、生活支援など、学生の多様なニーズに対応。大学生活を円滑に送るための各種サポートを実施します。',
      image: 'https://readdy.ai/api/search-image?query=Career%20counseling%20session%20with%20international%20students%20in%20Japan%2C%20friendly%20advisor%20helping%20students%2C%20modern%20consultation%20room%2C%20warm%20supportive%20atmosphere%2C%20professional%20educational%20setting&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-home-heart-line',
      title: '寮管理',
      description: '50名以上の学生が利用する安全で快適な学生宿舎を管理・運営。24時間対応のサポート体制で、学生が安心して生活できる環境を提供します。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20student%20dormitory%20interior%2C%20clean%20comfortable%20living%20space%2C%20bright%20natural%20lighting%2C%20safe%20and%20welcoming%20environment%2C%20well-maintained%20facilities&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-hammer-line',
      title: '不動産リフォーム工事・清掃代行',
      description: '不動産物件のリフォーム工事から日常清掃・原状回復まで幅広く対応。高品質な施工と丁寧な清掃で、物件の価値を最大限に引き出します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20renovation%20and%20cleaning%20service%20in%20Japan%2C%20bright%20modern%20apartment%20renovation%2C%20clean%20white%20walls%2C%20skilled%20workers%2C%20high%20quality%20finishing%2C%20fresh%20and%20tidy%20living%20space%20with%20natural%20light&width=400&height=300&seq=service4&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: '日中マーケティング調査業務',
      description: '日本と中国の両市場に精通した専門チームが、市場動向・競合分析・消費者調査を実施。ビジネス展開に必要な戦略的インサイトを提供します。',
      image: 'https://readdy.ai/api/search-image?query=Japan%20China%20business%20marketing%20research%2C%20professional%20team%20analyzing%20data%20charts%20in%20modern%20office%2C%20cross-cultural%20market%20analysis%2C%20clean%20bright%20workspace%2C%20business%20strategy%20meeting%20with%20graphs&width=400&height=300&seq=service5&orientation=landscape'
    },
    {
      icon: 'ri-building-2-line',
      title: '不動産・経営コンサルティング',
      description: '不動産投資・運用から経営戦略まで、豊富な実績を持つ専門家が課題解決をサポート。日中両国のビジネス環境に対応した最適なソリューションを提案します。',
      image: 'https://readdy.ai/api/search-image?query=Real%20estate%20and%20business%20consulting%20in%20Japan%2C%20professional%20consultant%20presenting%20property%20investment%20strategy%2C%20modern%20office%20with%20city%20view%2C%20business%20meeting%20with%20documents%20and%20charts%2C%20confident%20advisor&width=400&height=300&seq=service6&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs text-gray-500 mb-4">/ Our Services</p>
          <h2 className="text-4xl md:text-5xl font-light mb-6" style={{ fontFamily: 'serif' }}>
            主な事業内容
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            学生支援から不動産・マーケティングまで、多様なニーズにお応えする総合サービスを提供しております
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-amber-50/50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-medium mb-4 text-amber-900">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
